import { useEffect, useState, useCallback } from "react";
import { useIntl } from "react-intl";
import { LoadMoreButton } from "@rio-cloud/rio-uikit";

import MaintenanceTable from "./components/maintenanceTable";
import EmptyTable from "./components/emptyTable";
import EmptySelection from "../../../components/emptySelection";
import SkeletonTable from "./components/skeletonTable";
import BigNumbers from "../../../components/bigNumbers";

import useAssetsConnectionStatus from "../../../hooks/useAssetsConnectionStatus";
import useAssetsPlans from "../../../hooks/useAssetsPlans";
import useMaintenance from "../../../hooks/useMainteinance";
import useUptimeAssets from "../../../hooks/useUptimeAsset";
import useAssets from "../../../hooks/useAssets";

const PreventiveMaintenanceContent = (props: any) => {
  const intl = useIntl();
  const { allAssets } = useAssets();
  const {
    allSummaryAssets,
    assetIds,
    loading,
    loadMoreLoading,
    loadAssetsPaged,
    assets,
    getMoreAssets,
    page,
    assetIdsPaged,
    disableBigNumber,
  } = useMaintenance();
  const { uptimeAssets, getUptimeAssets, refreshUptimeAsset } = useUptimeAssets();
  const { assetsPlans, getAssetsPlans } = useAssetsPlans();
  const { assetsConnectionStatus, getAssetsConnectionStatus } =
    useAssetsConnectionStatus();

  const [availableToScheduleAssetIds, setAvailableToScheduleAssetIds] =
    useState<string[]>([]);

  const handleAssetUpdate = useCallback((assetId: string) => {
    refreshUptimeAsset(assetId);
  }, [refreshUptimeAsset]);

  useEffect(() => {
    if (props.assetIds?.length) {
      loadAssetsPaged(props.assetIds, true, allAssets);
    } else {
      loadAssetsPaged([], true, allAssets);
    }
  }, [props.assetIds, allAssets]);

  useEffect(() => {
    getUptimeAssets(
      assetIdsPaged[page]?.map((asset: any) => asset.id)
    );
    getAssetsPlans(assetIdsPaged[page]?.map((asset: any) => asset.id));
    getAssetsConnectionStatus(
      assetIdsPaged[page]?.map((asset: any) => asset.id)
    );
  }, [assetIdsPaged, page]);

  return (
    <>
      {loading ? (
        <BigNumbers
          assetIds={[]}
          setAssetIds={() => {}}
          assets={[]}
          bigTableLoading={loading}
          allAssets={allAssets}
          persona={props.persona}
          isSidebarOpen={props.isSidebarOpen}
        />
      ) : (
        <BigNumbers
          assetIds={assetIds}
          setAssetIds={(assetIds: string[] | undefined) =>
            loadAssetsPaged(assetIds, undefined, allAssets)
          }
          assets={allSummaryAssets}
          disabled={disableBigNumber}
          bigTableLoading={loading}
          allAssets={allAssets}
          persona={props.persona}
          setAvailableToScheduleAssetIds={setAvailableToScheduleAssetIds}
          isSidebarOpen={props.isSidebarOpen}
        />
      )}
      <div style={{ marginTop: 50 }}>
        {!props.assetIds?.length ? (
          <EmptySelection />
        ) : loading ? (
          <SkeletonTable />
        ) : (
          <>
            <MaintenanceTable
              assets={assets}
              uptimeAssets={uptimeAssets}
              assetsConnectionStatus={assetsConnectionStatus}
              assetsPlans={assetsPlans}
              availableToScheduleAssetIds={availableToScheduleAssetIds}
              allSummaryAssets={allSummaryAssets}
              isSidebarOpen={props.isSidebarOpen}
              onAssetUpdate={handleAssetUpdate}
            />
            {assets.length > 0 &&
              (loadMoreLoading ? (
                <SkeletonTable onlyRows />
              ) : (
                <LoadMoreButton
                  loaded={assets.length}
                  total={allSummaryAssets.length}
                  onLoadMore={getMoreAssets}
                  loadMoreMessage={intl.formatMessage({ id: "intl-msg:monitoring.loadMore" })}
                  noMoreMessage={intl.formatMessage({ id: "intl-msg:monitoring.allLoaded" })}
                />
              ))}

            {assets.length === 0 && <EmptyTable />}
          </>
        )}
      </div>
    </>
  );
};

const PreventiveMaintenance = (props: any) => {
  return <PreventiveMaintenanceContent {...props} />;
};

export default PreventiveMaintenance;
